import React, { Component } from 'react';
import {
  Button, Col, ControlLabel, FormControl, FormGroup, Row,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import _ from 'lodash';
import DatePicker from 'react-date-picker';

import ConfirmationModal from './ConfirmationModal.jsx';
import FieldTextBox from './forms/FieldTextBox.jsx';
import StateComboBox from './StateComboBox.jsx';
import MeasurementComboBox from './MeasurementComboBox.jsx';

import { setRatingType, enableSubmit, disableSubmit } from '../actions/ui';
import { updateField } from '../actions/form';
import { createProfile, fetchProfileOptions } from '../actions/profile';

import validation from '../lib/validation';

export class TeamSignup extends Component {
  constructor(props) {
    super(props);

    /* istanbul ignore next */
    this.state = {
      modal: null,
    };

    this.requiredFields = ['fullName', 'email', 'birthdate', 'mobileNumber'];

    this.onDropdownChange = this.onDropdownChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.saveForm = this.saveForm.bind(this);
    this.validateForm = this.validateForm.bind(this);
  }

  componentDidMount() {
    this.props.fetchProfileOptions();
    this.props.updateField('profile', 'profileType', 'team-member');
    this.props.setRatingType('profile');
  }

  componentDidUpdate() {
    this.saveForm();
  }

  validateForm() {
    const formFields = _.map(this.props.profile, (value, key) => key);
    const allRequiredFieldsFilledOut = _.every(this.requiredFields, requiredField => _.includes(formFields, requiredField));
    const allFieldsValid = _.every(formFields, field => validation.run(this.props.rules[field], this.props.profile[field]));
    const validForm = allRequiredFieldsFilledOut && allFieldsValid;

    return validForm;
  }

  saveForm() {
    if (this.validateForm()) this.props.enableSubmit();
    else this.props.disableSubmit();
  }

  onDropdownChange({ target }) {
    const { name: field, value } = target;

    this.props.updateField('profile', field, value);
    this.props.updateField('validation.profile', field, 'success');
    this.saveForm();
  }

  onSubmit() {
    if (!this.validateForm()) return;

    this.setState({
      modal: (
        <ConfirmationModal
          showModal
          onConfirm={this.props.createProfile}
          onClose={() => { this.setState({ modal: null }); }}
          message="Are you sure you want to submit your team member profile? This action cannot be undone."
        />
      ),
    });
  }

  render() {
    return (
      <form id="team-member-signup-form" autoComplete="off">
        <h1>TRD Team Member Sign-up</h1>
        <p className="subtext">All fields marked with an asterisk symbol (*) are mandatory.</p>
        {this.state.modal}
        <Row>
          <Col md={12}><h4 className="rating-type">Basic Info</h4></Col>
          <Col md={3}><FieldTextBox placeholder="* Full Name" field="fullName" /></Col>
          <Col md={3}><FieldTextBox placeholder="* Email" field="email" /></Col>
          <Col md={3}><FieldTextBox placeholder="* Phone #" field="mobileNumber" /></Col>
          <Col md={3}>
            <FormGroup id="birthdateGroup" validationState={this.props.validation.birthdate} controlId="teamMemberBirthdateInput">
              <DatePicker
                onChange={e => this.onDropdownChange({ target: { name: 'birthdate', value: e } })}
                value={this.props.profile.birthdate}
                clearIcon={null}
                required
              />
              <FormControl.Feedback />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={12}><h4 className="rating-type">Address</h4></Col>

          <Col md={6}><FieldTextBox placeholder="Mailing Address" field="mailingAddress" /></Col>
          <Col md={3}>
            <FormGroup validationState={this.props.validation.mailingAddressState} className="dropdownSelect" controlId="driverMailingAddressStateInput">
              <StateComboBox
                name="mailingAddressState"
                selected={_.get(this.props, 'profile.mailingAddressState', '')}
                onChange={this.onDropdownChange}
              />
              <FormControl.Feedback className="select-feedback" />
              <ControlLabel className="glyphicon glyphicon-chevron-down dropdown-arrow" />
            </FormGroup>
          </Col>
          <Col md={3}><FieldTextBox placeholder="ZIP Code" field="mailingAddressZip" /></Col>

          <Col md={6}><FieldTextBox placeholder="Residential Address" field="residentialAddress" /></Col>
          <Col md={3}>
            <FormGroup validationState={this.props.validation.residentialAddressState} className="dropdownSelect" controlId="driverresidentialAddressStateInput">
              <StateComboBox
                name="residentialAddressState"
                selected={_.get(this.props, 'profile.residentialAddressState', '')}
                onChange={this.onDropdownChange}
              />
              <FormControl.Feedback className="select-feedback" />
              <ControlLabel className="glyphicon glyphicon-chevron-down dropdown-arrow" />
            </FormGroup>
          </Col>
          <Col md={3}><FieldTextBox placeholder="ZIP Code" field="residentialAddressZip" /></Col>

        </Row>

        <Row>
          <Col md={12}><h4 className="rating-type">Online Presence</h4></Col>
          <Col md={3}><FieldTextBox placeholder="Facebook URL" field="facebook" /></Col>
          <Col md={3}><FieldTextBox placeholder="Instagram URL" field="instagram" /></Col>
          <Col md={3}><FieldTextBox placeholder="Twitter URL" field="twitter" /></Col>
          <Col md={3}><FieldTextBox placeholder="Website URL" field="website" /></Col>
        </Row>

        <Row>
          <Col md={12}><h4 className="rating-type">Measurements</h4></Col>
          <Col md={4}>
            <FormGroup validationState={this.props.validation.shirtSize} className="dropdownSelect" controlId="drivershirtSizeInput">
              <MeasurementComboBox
                name="shirtSize"
                displayName="T-Shirt/Polo Size"
                selected={this.props.profile.shirtSize}
                onChange={this.onDropdownChange}
              />
              <FormControl.Feedback className="select-feedback" />
              <ControlLabel className="glyphicon glyphicon-chevron-down dropdown-arrow" />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup validationState={this.props.validation.jacketSize} className="dropdownSelect" controlId="driverjacketSizeInput">
              <MeasurementComboBox
                name="jacketSize"
                displayName="Jacket Size"
                selected={this.props.profile.jacketSize}
                onChange={this.onDropdownChange}
              />
              <FormControl.Feedback className="select-feedback" />
              <ControlLabel className="glyphicon glyphicon-chevron-down dropdown-arrow" />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup validationState={this.props.validation.hatSize} className="dropdownSelect" controlId="driverhatSizeInput">
              <MeasurementComboBox
                name="hatSize"
                displayName="Hat Size"
                selected={this.props.profile.hatSize}
                measurements={['S', 'M', 'L', 'XL']}
                onChange={this.onDropdownChange}
              />
              <FormControl.Feedback className="select-feedback" />
              <ControlLabel className="glyphicon glyphicon-chevron-down dropdown-arrow" />
            </FormGroup>
          </Col>
        </Row>

        <Button
          onClick={this.onSubmit}
          className="col-sm-12 next-btn"
          disabled={this.props.submitDisabled}
        >
          Submit
        </Button>
      </form>
    );
  }
}

export const mapStateToProps = state => ({
  rules: state.validation.profile.fields,
  submitDisabled: state.ui.submitDisabled,
  profile: state.form.profile.fields,
  validation: state.form.validation.profile.fields,
});

export default connect(
  mapStateToProps,
  {
    updateField,
    createProfile,
    fetchProfileOptions,
    setRatingType,
    enableSubmit,
    disableSubmit,
  },
)(TeamSignup);
